import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { StoresService } from './stores.service';
import { IStore } from 'src/app/appModels/IStore';
import { LoaderUtility } from 'src/app/appUtilities/loader.utility';

@Injectable({
  providedIn: 'root',
})
export class StoreResolver {
  changeStoreClick = new Subject();
  storeList = new BehaviorSubject<IStore[] | null>(null);
  selectedStore = new BehaviorSubject<IStore | null>(null);

  constructor(
    private _storeService: StoresService,
    private _loaderUtility: LoaderUtility,
  ) { }

  /**
   * Setup subscribe store list
   */
  async setupStore(set?: boolean) {
    if (this.storeList.value) {
      return;
    }
    await this._loaderUtility.showLoader();
    this._storeService.getAllStores().subscribe(
      async (res: IStore[]) => {
        await this._loaderUtility.hideLoader();
        this.setStoreList(res);
        if (set) this.changeStoreClick.next(null);
      },
      async (err) => {
        await this._loaderUtility.hideLoader();
      }
    );
  }

  /**
   * Set Store list
   * @param storeList
   */
  setStoreList(storeList: IStore[]) {
    this.storeList.next(storeList);
  }

  /**
   * set selected store
   * @param store
   */
  public setSelectedStore(store: IStore) {
    const currentStore = this.selectedStore.getValue();

    // Compare references or specific properties
    if (JSON.stringify(currentStore) === JSON.stringify(store)) {
      return; // Don't emit if the store hasn't changed
    }
    this.selectedStore.next(store);
  }

  /**
   * clear Selected store
   */
  public clearSelectedStore(): void {
    this.selectedStore.next(null);
  }


  /**
   * Clear storage
   */
  clear() {
    this.storeList.next(null);
    this.selectedStore.next(null);
  }


}
